import type { ThemeData } from './types';

/**
 * Преобразует ключ темы (snake_case от API) в имя CSS-переменной (--kebab-case).
 *
 * @example
 * themeKeyToCssVar('color_background') => '--color-background'
 */
export const themeKeyToCssVar = (key: string): string => {
  const kebabCase = key.replace(/_/g, '-').toLowerCase();
  return `--${kebabCase}`;
};

/**
 * Преобразует ThemeData (colorParameter с code в snake_case) в объект CSS-переменных (--kebab-case).
 * Единственный способ получения CSS-переменных из формата API/конфига.
 *
 * @param theme - Данные темы с массивом colorParameter (code в snake_case)
 * @returns Объект с CSS-переменными для применения на :root
 */
export const convertThemeDataToCssVariables = (theme: ThemeData): Record<string, string> => {
  const cssVariables: Record<string, string> = {};
  for (const param of theme.colorParameter) {
    const cssVarName = themeKeyToCssVar(param.code);
    cssVariables[cssVarName] = param.colorHex;
  }
  return cssVariables;
};
